var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Bluebird from "bluebird";
import socketService from "../services/socket.service";
import ObjectLoader from "../services/mutableObjectLoader";
import { withPrefix } from "../services/storage.service";
var sessionStorage = withPrefix("whispeer.session");
var Company = /** @class */ (function () {
    function Company(company) {
        var _this = this;
        this.company = company;
        this.get = function () { return _this.company; };
        this.getUserIDs = function () { return _this.company.userIDs; };
    }
    Company.prototype.set = function (company) {
        this.company = company;
    };
    return Company;
}());
export { Company };
var CompanyLoader = /** @class */ (function (_super) {
    __extends(CompanyLoader, _super);
    function CompanyLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CompanyLoader;
}(ObjectLoader({
    download: function (id) { return socketService.definitlyEmit("company.get", { id: id }).then(function (response) { return response.company; }); },
    load: function (company) { return Bluebird.resolve(company); },
    getID: function (company) { return company.id; },
    restore: function (company, previousInstance) {
        if (previousInstance) {
            previousInstance.set(company);
            return previousInstance;
        }
        return new Company(company);
    },
    shouldUpdate: function () { return Bluebird.delay(2000).thenReturn(true); },
    cacheName: "company"
})));
export default CompanyLoader;
export var getOwnCompanyID = function () {
    var companyID = sessionStorage.get("companyID");
    if (companyID) {
        return Bluebird.resolve(companyID);
    }
    return socketService.definitlyEmit("company.ownCompanyID", {})
        .then(function (_a) {
        var companyID = _a.companyID;
        return companyID;
    })
        .then(function (companyID) {
        if (!companyID) {
            throw new Error("No company id");
        }
        sessionStorage.set("companyID", companyID);
        return companyID;
    });
};



//////////////////
// WEBPACK FOOTER
// ./js/services/companyService.ts
// module id = null
// module chunks = 